import isFunction from './isFunction.js';
import isLength from './isLength.js';

function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}

export { isArrayLike as default };
